import { useMutation } from '@apollo/react-hooks';
import {
  UpdateArticleGroupMutation,
  UpdateArticleGroupMutationVariables
} from './__generated__/UpdateArticleGroupMutation';
import { kmsClient } from 'api';
import { UPDATE_ARTICLE_GROUP_MUTATION } from './updateArticleGroup.mutation';

type MutationProps = {
  onStart?: () => void;
  onCompleted?: () => void;
  onError?: (errors: string[]) => void;
};

export const useUpdateArticleGroup = ({ onStart, onCompleted, onError }: MutationProps) => {
  const [updateArticleGroup] = useMutation<UpdateArticleGroupMutation, UpdateArticleGroupMutationVariables>(
    UPDATE_ARTICLE_GROUP_MUTATION,
    {
      client: kmsClient,
      onCompleted: (data) => {
        if (data.updateArticleGroup?.errors?.length) {
          if (onError) onError(data.updateArticleGroup.errors);
        } else {
          if (onCompleted) onCompleted();
        }
      },
      onError: (error) => onError && onError([error.message])
    }
  );
  return (variables: UpdateArticleGroupMutationVariables) => {
    if (onStart) onStart();
    updateArticleGroup({ variables });
  };
};
